@import "../core/fonts.css";

.dialogContent {
	width: 100%;
	color: black;
	font-size: 14px;
}

.header {
	display: flex;
	flex-direction: column;
	align-items: center;
	border-bottom: 1px solid #b3b3b3;
}

.animation {
	width: 180px;
	height: 200px;
}

h2.headerText {
	font-size: 15px;
	font-weight: 500;
	line-height: 15px;
	text-align: center;
	color: #000000;
	margin: 0px;
}

.launchBtn {
	font-size: 15px !important;
	font-weight: 700 !important;
	line-height: 15px !important;
	letter-spacing: 0em !important;
	text-align: left !important;
	width: 100% !important;
	height: 40px !important;
	margin-bottom: 20px !important;
	margin-top: 20px !important;
}

.content {
	padding-top: 20px;
	display: flex;
	flex-direction: column;
	align-items: stretch;
}

.mainInstructions {
	text-align: left;
	margin: 0;
	margin-bottom: 15px;
	font-size: 14px;
	font-weight: 500;
	line-height: 20px;
	letter-spacing: 0em;
	color: #000000;
}

.section {
	border-radius: 5px;
	background: #eceaf1;
	padding: 5px;
}

.steps {
	display: flex;
	flex-direction: column;
	gap: 20px;
	padding-left: 8%;
}

.steps li {
	font-size: 13px;
	font-weight: 700;
}

.steps li button {
	display: block;
	margin-top: 10px;
	margin-left: -15px;
}

.note {
	font-size: 12px;
	margin: 20px 20px 0;
}

.or {
	display: flex;
	align-items: center;
	gap: 10px;
	font-size: 12px;
	margin: 14px 20px;
}

.or::before,
.or::after {
	content: "";
	height: 1px;
	flex: 1;
	background-color: #b3b3b3;
}

.linkRow {
	display: flex;
	gap: 8px;
	margin-top: 20px;
}

.linkRow div:first-child {
	flex: 1;
	font-size: 13px;
}

.linkRow button {
	min-width: 0;
	padding: 4px 8px;
}

.linkRow button svg {
	font-size: 12px;
}

a.supportLink {
	text-align: center;
	font-size: 13px;
	margin-top: 18px;
}

.flexDirec {
	display: flex;
	flex-direction: row;
	justify-content: left;
	gap: 10%;
}

.flexDirecMid {
	display: flex;
	flex-direction: row;
	justify-content: right;
}

.marginL {
	margin-left: 7%;
	width: 130px;
	height: 130px;
	margin-top: 5%;
}

.downloadBtnOverall {
	display: flex;
	flex-direction: row;
	align-items: center;
}

.downloadBtnText {
	display: flex;
	flex-direction: column;
}

.downloadBtnText1 {
	font-size: 15px;
	font-weight: 400;
	color: #000000;
}

.downloadBtnText2 {
	font-size: 17px;
	font-weight: 700;
	color: #000000;
}
